import { arrayOf, func, object, shape, string } from 'prop-types';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { components } from 'react-select';
import { Button } from 'reactstrap';

import api from '../../../REST/api';
import withApiRequest from '../../../REST/with-api-request';
import { flash } from '../../../utils/flash';

const endpoint = api.getClmContentPreview;

const ContentEntryNameMenu = props => {
  const { children, selectProps, onRequest } = props;
  const {
    campaignLineProducts,
    chosenFilters,
    setChosenFilters,
    onClearSelected,
    campaignId,
    onSuccess,
  } = selectProps;

  const handleBadgeClick = productCode => {
    if (!chosenFilters.includes(productCode)) {
      setChosenFilters([...chosenFilters, productCode]);
    } else {
      setChosenFilters(chosenFilters.filter(code => code !== productCode));
    }
  };

  const selectedOptions = props.getValue();
  const contentIds = selectedOptions.map(option => option.value);

  const addCreatives = () =>
    onRequest({ data: { contentIds, campaignId } })
      .then(files => {
        onSuccess(files);
        onClearSelected();
        document.activeElement?.blur();
        const returnedIds = Object.keys(files?.clmContentPreview || {});
        if (returnedIds.length === 0) {
          flash(
            "No matching creatives found for the entered content ID(s). Check that the IDs exist in the correct environment and that their content types support this campaign's product, offer type, and proposition.",
            'warning',
          );
        } else {
          const missingIds = contentIds.filter(id => !returnedIds.includes(id));
          if (missingIds.length > 0) {
            flash(
              `Some content IDs could not be added: ${missingIds.join(
                ', ',
              )}. Check their availability and compatibility with this campaign.`,
              'warning',
            );
          } else {
            flash('Contentful Creatives uploaded successfully');
          }
        }
      })
      .catch(console.error); // eslint-disable-line no-console

  return (
    <components.MenuList {...props}>
      <div style={{ maxHeight: 400, display: 'flex', flexDirection: 'column' }}>
        <div
          className="m-2 d-flex flex-wrap gap-1 p-2 border-bottom bg-white"
          style={{ position: 'sticky', top: 0, zIndex: 1 }}
        >
          {campaignLineProducts.map(product => (
            <Button
              key={product.value}
              color="secondary"
              size="sm"
              className="m-1 position-relative rounded-pill px-3 py-1 d-flex align-items-center"
              onClick={() => handleBadgeClick(product.code)}
              active={chosenFilters.includes(product.code)}
              outline
            >
              {chosenFilters.includes(product.code) && (
                <RxCross2 className="ms-2" style={{ pointerEvents: 'none' }} />
              )}
              {product.label}
            </Button>
          ))}
        </div>

        <div style={{ overflowY: 'auto', flex: 1 }}>{children}</div>

        <div
          className="d-flex justify-content-end p-2 border-top bg-white"
          style={{ position: 'sticky', bottom: 0, zIndex: 1 }}
        >
          <Button size="sm" onClick={addCreatives}>
            + Add Creatives
          </Button>
        </div>
      </div>
    </components.MenuList>
  );
};

ContentEntryNameMenu.propTypes = {
  selectProps: shape({
    campaignLineProducts: arrayOf(
      shape({
        label: string,
        value: string,
      }),
    ),
  }).isRequired,
  onRequest: func.isRequired,
  getValue: func.isRequired,
  children: object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withApiRequest({
  query: endpoint,
})(ContentEntryNameMenu);
